/*---------------React & Libraries-----------------*/
import React from "react";
import { Link as RouterLink } from "react-router-dom";

/*---------------Material UI Components-----------*/
import {
  Breadcrumbs,
  Link as MuiLink,
  Typography,
  BreadcrumbsProps,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

/*---------------Models---------------------------*/
import { BreadcrumbItem } from "../../../models/miscellaneous";

interface BreadcrumbsNavProps extends BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const BreadcrumbsNav: React.FC<BreadcrumbsNavProps> = ({ items, ...props }) => {
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      {...props}
    >
      {items.map((item, index) =>
        item.href ? (
          <MuiLink
            key={index}
            component={RouterLink}
            to={item.href}
            underline="hover"
            color="inherit"
            sx={{ cursor: "pointer" }}
          >
            {item.label}
          </MuiLink>
        ) : (
          <Typography key={index} color="primary" fontWeight={600}>
            {item.label}
          </Typography>
        )
      )}
    </Breadcrumbs>
  );
};

export default BreadcrumbsNav;
